var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AssociatedProduct } from './associated-product';
import { ProductBaseFactory } from '../ProductFactory/IIncompleteProductBase';
var AssociatedProductFactory = /** @class */ (function (_super) {
    __extends(AssociatedProductFactory, _super);
    function AssociatedProductFactory(injector) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        return _this;
    }
    AssociatedProductFactory.prototype.withMetadataAsync = function (generationName) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.productService.getProductList(generationName).toPromise()];
                    case 1:
                        _a.metaData = _b.sent();
                        return [2 /*return*/, this];
                    case 2:
                        err_1 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AssociatedProductFactory.prototype.forRiderProduct = function (MetaDataProduct) {
        this.metaDataProduct = MetaDataProduct;
        return this;
    };
    AssociatedProductFactory.prototype.setCurrentMainProducUID = function (MainProductUID) {
        this.MainProductUID = MainProductUID;
        return this;
    };
    AssociatedProductFactory.prototype.extractRequirementType = function () {
        var _this = this;
        try {
            this.requirementType = this.metaDataProduct.ProductRequirements_2.find(function (x) { return x.ProductConfig.UID === _this.MainProductUID; }).RequirementType;
            return this;
        }
        catch (e) {
            return null;
        }
    };
    AssociatedProductFactory.prototype.extractRiderPolicy = function () {
        var _this = this;
        try {
            this.riderPolicy = this.metaDataProduct.ProductRequirements_2.find(function (x) { return x.ProductConfig.UID === _this.MainProductUID; }).RiderPolicy;
            return this;
        }
        catch (e) {
            return null;
        }
    };
    AssociatedProductFactory.prototype.extractAccelerator = function () {
        var _this = this;
        try {
            this.Accelerator = this.metaDataProduct.ProductRequirements_2.find(function (x) { return x.ProductConfig.UID === _this.MainProductUID; }).Accelerator;
            return this;
        }
        catch (e) {
            return null;
        }
    };
    AssociatedProductFactory.prototype.build = function () {
        return new AssociatedProduct(this.uid, this.name, this.minBenefitAmount, this.maxBenefitAmount, this.benefitPatternSet, this.premiumPatternSet, this.eventSet, this.category, this.displayName, [], this.defaultBenefitPattern, this.defaultPremiumPattern, this.rateTable, this.requirementType, this.riderPolicy, this.Accelerator, this.isDisability, this.isParentDependent, this.dependentParentGuid);
    };
    return AssociatedProductFactory;
}(ProductBaseFactory));
export { AssociatedProductFactory };
